import {Directive, ElementRef, Renderer2, OnInit, Inject, Input, AfterViewInit} from '@angular/core';
import {ICON_SVG_ASSET_CONFIG, SvgAssetIconConfig} from "./svg-asset.models";


@Directive({
  selector: '[svgAssetOutlet]',
  host: {
    '[class]': "'ta-svg-asset-outlet'"
  }
})
export class SvgAssetOutletDirective implements OnInit, AfterViewInit {
  @Input('svgAssetOutlet') renderName = '';
  @Input('alt') alt = '';
  constructor(
    @Inject(ICON_SVG_ASSET_CONFIG) private config: SvgAssetIconConfig,
    private el: ElementRef, private rd: Renderer2
  ) { }

  ngOnInit() {
    /** Put SVG centered vertically */
    this.rd.setStyle(this.el.nativeElement, 'display', 'inline-flex');
    this.rd.setStyle(this.el.nativeElement, 'align-items', 'center');
  }

  ngAfterViewInit() {
    /** Place SVG inside element & display it */
    this.rd.setProperty(this.el.nativeElement, 'innerHTML', this.config?.svgAssets?.[this.renderName] || '(' + this.alt + '?' + ')');
    this.rd.setProperty(this.el.nativeElement, 'alt', this.alt);
  }

}
